import { DO_NOT_USE_FaWrapper } from '../../../../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';
import { IconButton } from '../../../../../navigation/buttons/IconButton/IconButton.js';

var TableRowCollapseButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var open = props.open,
    onClick = props.onClick;
  var icon = open ? /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
    icon: faChevronUp
  }) : /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
    icon: faChevronDown
  });
  return /*#__PURE__*/jsx(IconButton, {
    ref: ref,
    size: "small",
    onClick: onClick,
    "aria-expanded": open,
    appearance: "ghost",
    children: icon
  });
});

export { TableRowCollapseButton };
